import axiosWrapper from "common/axiosWrapper";

const baseUrl = "/api/event";

/** The Event service which calls the API endpoints for the Event Controller */
export default class EventService {
	/** Gets the next event. */
	static async getNextEventId() {
		return await axiosWrapper.get(`${baseUrl}/next`);
	}

	/** Gets the previous event. */
	static async getPreviousEventId() {
		return await axiosWrapper.get(`${baseUrl}/previous`);
	}

	/** Gets the current event for each active game. Events can be in the future or the past. */
	static async getCurrentEvents() {
		return await axiosWrapper.getCached(`${baseUrl}/currentEvents`);
	}

	/** Gets the current season's events for the current game */
	static async getCurrentSeasonEvents() {
		return await axiosWrapper.getCached(`${baseUrl}/getSeasonEvents`);
	}

	/** Gets the event. */
	static async getEvent(eventId) {
		if (!eventId) {
			return null;
		}
		return await axiosWrapper.get(`${baseUrl}/get?eventId=${eventId}`);
	}

	/** Gets events. */
	static async getEvents(gameId) {
		return await axiosWrapper.get(`${baseUrl}/getEvents?gameId=${gameId}`);
	}

	static async getEventsNotRewarded() {
		return await axiosWrapper.get(`${baseUrl}/notRewarded`);
	}

	/** Gets active events (live + unlocked, end date not passed) for the current game. */
	static async getActiveEvents() {
		return await axiosWrapper.get(`${baseUrl}/active`);
	}

	/** Gets stage, pick and sync state for an event, plus what is blocking it from advancing. */
	static async getDiagnostics(eventId) {
		return await axiosWrapper.get(`${baseUrl}/diagnostics?eventId=${eventId}`);
	}

	/** Gets recent + upcoming events for a game (including hidden ones) for the Event Manager. */
	static async getManagedEvents(gameId) {
		return await axiosWrapper.get(`${baseUrl}/manage?gameId=${gameId}`);
	}

	/** Updates an event's display name, image, and hidden state. */
	static async updateEventDetails(payload) {
		return await axiosWrapper.post(`${baseUrl}/updateDetails`, payload);
	}

	/** Forces an immediate Liquipedia sync of the event, bypassing the round-robin throttle. */
	static async syncNow(eventId) {
		return await axiosWrapper.post(`${baseUrl}/syncNow?eventId=${eventId}`, {});
	}

	/** Sends the pending stage-open push for a hand-opened stage. */
	static async notifyStageOpen(eventId) {
		return await axiosWrapper.post(
			`${baseUrl}/notifyStageOpen?eventId=${eventId}`,
			{}
		);
	}

	/** Gets the official match picks. */
	static async getOfficialMatchPicks(eventId) {
		return await axiosWrapper.get(`${baseUrl}/official?eventId=${eventId}`);
	}

	/**
	 * Gets the past event ids.
	 *
	 * @returns {Promise<Array<number>>} The past event ids.
	 */
	static async getPastEventIds() {
		return await axiosWrapper.get(`${baseUrl}/allPastEventIds`);
	}

	static async getEventImages() {
		return await axiosWrapper.getCached(`${baseUrl}/eventImages`);
	}

	static async updateTeams(teamInfo) {
		return await axiosWrapper.post(`${baseUrl}/updateteams`, teamInfo);
	}

	static async getSwissStagePickData(eventId) {
		return await axiosWrapper.get(`${baseUrl}/swissstage?eventId=${eventId}`);
	}
}
